// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"57":"ad60c4f5b644a88df785","936":"4948b0d61762a0a149d4"}[chunkId] + "/css/" + (chunkId === 57 ? "index" : chunkId) + ".css";
};